import { ReactElement, useState } from 'react';
import { ACTION_LINK_ICON_NAME, ACTION_LINK_ICON_SIZE, ActionLink } from 'b2b-components/theme/components/ActionLink';
import { useTranslate } from 'b2b-apps/core/i18n/hooks';
import { Form } from 'b2b-apps/core/product/components/ProductDetails/ProductReportForm/Form';
import './ProductReportForm.scss';

export const ProductReportForm = (): ReactElement => {
  const t = useTranslate();
  const [isFormVisible, setIsFormVisible] = useState(false);

  const handleFormShow = () => {
    setIsFormVisible(true);
  };

  const handleFormHide = () => {
    setIsFormVisible(false);
  };

  return (
    <div className='ProductReportForm row'>
      <div className='col-12 col-lg-6'>
        {isFormVisible ? (
          <Form onFormHide={handleFormHide} />
        ) : (
          <ActionLink
            iconName={ACTION_LINK_ICON_NAME.reportError}
            iconSize={ACTION_LINK_ICON_SIZE.small}
            onClick={handleFormShow}
            className='ProductReportForm-Toggler'
          >
            {t('Report incorrect data')}
          </ActionLink>
        )}
      </div>
    </div>
  );
};
